var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart',{ref:"highchartChart",staticClass:"pie-chart analytics-chart",attrs:{"options":_vm.chartOptions,"callback":_vm.chartCallback}})}
var staticRenderFns = []

export { render, staticRenderFns }